<template>
  <div>
    <FilterSelect v-if="customfield.type === 'select'"
                  :title="customfield.name"
                  :options="options"
                  v-on="$listeners" />
    <FilterText v-else
                :title="customfield.name"
                v-on="$listeners" />
  </div>
</template>

<script>
import FilterSelect from "./FilterSelect";
import FilterText from "./FilterText";

export default {
  inheritAttrs: false,

  props: {
    customfield: {
      type: Object,
      required: true
    }
  },

  components: {
    FilterSelect,
    FilterText
  },

  computed: {
    options() {
      if (this.customfield.options) {
        return this.customfield.options.map(option => ({
          value: option,
          text: option
        }));
      } else {
        return []
      }
    }
  }
};
</script>
